export default defineAppConfig({
    ui: {
        primary: 'blurple',
        secondary: 'deepplumb',
    },
})
